import { render, staticRenderFns } from "./book-manage.vue?vue&type=template&id=48b37b74&scoped=true"
import script from "./book-manage.vue?vue&type=script&lang=js"
export * from "./book-manage.vue?vue&type=script&lang=js"
import style0 from "./book-manage.vue?vue&type=style&index=0&id=48b37b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b37b74",
  null
  
)

export default component.exports